import { useGraphql } from 'utils/hooks/useGraphql';
import { UseCampaignLabelsHookOutput, UseCampaignLabelsQueryData } from './types';
import { DEFAULT_CAMPAIGN_LABELS, USE_CAMPAIGN_LABELS_HOOK_QUERY } from './constants';

export const useCampaignLabels = (): UseCampaignLabelsHookOutput => {
  const {
    data,
    error: didError,
    isLoading,
  } = useGraphql<UseCampaignLabelsQueryData>(USE_CAMPAIGN_LABELS_HOOK_QUERY);
  return {
    campaignLabels: data?.campaignLabels ?? DEFAULT_CAMPAIGN_LABELS,
    didError,
    isLoading,
  };
};
